'use client';

import { createClient } from '@/lib/supabase/client';

export interface ConsentSettings {
  id: string;
  enabled: boolean;
  consentText: string;
  privacyPolicyUrl: string;
  termsUrl: string;
  updatedAt: string;
}

function toConsentSettings(row: any): ConsentSettings {
  return {
    id: row.id,
    enabled: row.enabled ?? false,
    consentText: row.consent_text ?? "I accept 3T Software Labs' Privacy Policy and Terms of Service",
    privacyPolicyUrl: row.privacy_policy_url ?? 'https://studio3t.com/privacy-policy/',
    termsUrl: row.terms_url ?? 'https://studio3t.com/terms-of-service/',
    updatedAt: row.updated_at,
  };
}

export const consentSettingsService = {
  async getSettings(): Promise<ConsentSettings | null> {
    const supabase = createClient();
    const { data, error } = await supabase
      .from('consent_settings')
      .select('*')
      .eq('id', 'default')
      .single();

    if (error || !data) {
      // Return defaults if table doesn't exist yet
      return {
        id: 'default',enabled: true,consentText: "I accept 3T Software Labs\' Privacy Policy and Terms of Service",privacyPolicyUrl: 'https://studio3t.com/privacy-policy/',termsUrl: 'https://studio3t.com/terms-of-service/',
        updatedAt: new Date().toISOString(),
      };
    }
    return toConsentSettings(data);
  },

  async saveSettings(settings: Partial<Omit<ConsentSettings, 'id' | 'updatedAt'>>): Promise<void> {
    const supabase = createClient();
    const { error } = await supabase.from('consent_settings').upsert({
      id: 'default',
      ...(settings.enabled !== undefined && { enabled: settings.enabled }),
      ...(settings.consentText !== undefined && { consent_text: settings.consentText }),
      ...(settings.privacyPolicyUrl !== undefined && { privacy_policy_url: settings.privacyPolicyUrl }),
      ...(settings.termsUrl !== undefined && { terms_url: settings.termsUrl }),
      updated_at: new Date().toISOString(),
    });

    if (error) throw new Error(error.message);
  },
};
